export default __webpack_public_path__ + "7f1268229af13f55c608c31e93a75c6a9d564eaf1e7424995531109a3bd7ec01.png";